module.exports = __webpack_public_path__ + "static/media/giraffe bball.74f48fd8.jpg";